export const queryFirstMatchingSelector = (
  selectorList: string,
  root: ParentNode = document,
): Element | null => {
  const trimmed = selectorList.trim();
  if (!trimmed) return null;

  if (!trimmed.includes(',')) {
    return root.querySelector(trimmed);
  }

  const selectors = trimmed
    .split(',')
    .map((selector) => selector.trim())
    .filter(Boolean);

  for (const selector of selectors) {
    const el = root.querySelector(selector);
    if (el) return el;
  }

  return selectors[0] ? root.querySelector(selectors[0]) : null;
};
